<template>
  <div
    class="product-gallery"
    :class="{ 'product-gallery--loading': loading }"
    v-if="!loading && typeof currentProduct !== 'undefined' && typeof this.currentProduct.fields.gallery !== 'undefined'">

    <!-- Mobile: let's do a swiper -->
    <ProductGallerySwiper 
      :images="this.currentProduct.fields.gallery"
      v-if="matchMedia === 'small' && typologyMap !== 'product-gallery__listing--100'"/>

    <!-- >= than medium: let's do a normal gallery -->
    <div 
      v-else
      class="product-gallery__normal-gallery">
      <!-- More than one picture - img are backgrounds cover -->
      <div
        v-if="typologyMap !== 'product-gallery__listing--100' && typologyMap !== ''"
        :class="typologyMap"
        class="product-gallery__listing"
        :style="'height:' + maxHeight">
        <div
          v-for="(image, index) of currentProduct.fields.gallery"
          :key="index"
          :style="'background-image:url(' + image.fields.file.url + ')'" />
      </div>
      <!-- Just one picture - normal img tag -->
      <div
        v-if="typologyMap === 'product-gallery__listing--100'"
        :class="typologyMap"
        class="product-gallery__listing">
        <picture v-lazy-container="{ selector: 'img' }">
          <source media="(min-width: 1600px)" :srcset="srcSet['1600']">
          <source media="(min-width: 1440px)" :srcset="srcSet['1440']">
          <source media="(min-width: 1024)" :srcset="srcSet['1024']">
          <source media="(min-width: 640)" :srcset="srcSet['640']">
          <source :srcset="srcSet['1600'] + ' 2x, ' + srcSet['640'] + ' 1x'" />
          <img :data-src="srcSet['640']" :data-loading="lazyLoading" alt="Flowers">
        </picture>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import matchMedia from '@/mixins/matchMedia.js'
import ProductGallerySwiper from '@/components/ProductGallery/ProductGallerySwiper/ProductGallerySwiper.vue'

const types = {
  1: 'product-gallery__listing--100',
  2: 'product-gallery__listing--40-60',
  3: 'product-gallery__listing--5050-50'
}

export default {
  name: 'ProductGallery',
  mixins: [matchMedia],
  components: {
    ProductGallerySwiper
  },
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/product-gallery.png')
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    currentProduct: {
      get () {
        if (this.loading) return undefined
        return this.product(this.slug)
      }
    },
    typologyMap: {
      get () {
        if (this.loading) return ''
        return types[this.currentProduct.fields.gallery.length]
      }
    },
    maxHeight: {
      get () {
        if (this.loading) return '0'
        var maxElementHeight = 0
        this.currentProduct.fields.gallery.forEach((element) => {
            if (element.fields.file.details.image.height > maxElementHeight) maxElementHeight = element.fields.file.details.image.height
        })
        if (maxElementHeight > window.innerHeight) return window.innerHeight - (window.innerHeight * 10/100) + 'px'
        return maxElementHeight + 'px'
      }
    },
    srcSet: {
      get () {
        if (this.loading) return undefined
        if (typeof this.currentProduct.fields.gallery === 'undefined') return undefined
        return {
          '640': `${this.currentProduct.fields.gallery[0].fields.file.url}?w=640&fit=scale`,
          '1024': `${this.currentProduct.fields.gallery[0].fields.file.url}?w=1024&fit=scale`,
          '1440': `${this.currentProduct.fields.gallery[0].fields.file.url}?w=1440&fit=scale`,
          '1600': `${this.currentProduct.fields.gallery[0].fields.file.url}`
        }
        /*
        return Object.keys(srcSetImages)
          .map(width => parseInt(width, 10))
          .sort((a, b) => a - b)
          .reduce((srcSet, width) => `${srcSet} ${srcSetImages[width]} ${width}w,`, '')
          .slice(0, -1)
        */
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        // await this.loadImage()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    async loadImage () {
      // https://www.contentful.com/developers/docs/references/images-api/#/reference/resizing-&-cropping/change-the-resizing-behavior/retrieve-an-image/console/js
      try {
        const assetId = this.currentProduct.fields.gallery[0].sys.id
        const asset = await this.$contentful.getAsset(assetId)
        const srcSetImages = {
          '640': `${asset.fields.file.url}?w=640&fit=scale`,
          '1024': `${asset.fields.file.url}?w=1024&fit=scale`,
          '1440': `${asset.fields.file.url}?w=1440&fit=scale`,
          '1920': `${asset.fields.file.url}?w=1920&fit=scale`
        }
        this.srcSet = Object.keys(srcSetImages)
          .map(width => parseInt(width, 10))
          .sort((a, b) => a - b)
          .reduce((srcSet, width) => `${srcSet} ${srcSetImages[width]} ${width}w,`, '')
          .slice(0, -1)
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
